import React from 'react';
import {Button, Form, FormGroup, Input, Media, Modal, ModalBody, ModalHeader} from 'reactstrap';
import {I18n} from '../../I18n/components/companyMarket';
import spinner from '../../assets/images/spinner.gif';

import './companyMarket.css'

const UploadModal = (props) => {
	return (
		<Modal className="upload-modal" isOpen={props.uploadModal} toggle={props.toggleUploadModal}>
			<ModalHeader toggle={props.toggle}>{I18n[props.lang].uploadApk}</ModalHeader>
			<ModalBody>
				<Form onSubmit={props.sendFile}>
					<FormGroup className="mb-1">
						<div className="custom-file">
							<Input
								type="file"
								className="custom-file-input"
								id="upload_apk"
								multiple
								onChange={props.onFileSelect}/>
							<label className="custom-file-label" id="upload_apk_label" htmlFor="upload_apk">{props.uploadApkName}</label>
						</div>
					</FormGroup>
					<FormGroup className="upload modal-buttons">
						<Media
							className={!props.isApkUpload ?
								'modal-buttons__download visually-hidden' : 'modal-buttons__download'}
							object
							src={spinner}
							alt="upload spinner"
						/>
						<span className={!props.isApkUpload && Number.parseInt(props.progressPercent) < 1 ? 'modal-buttons__progress visually-hidden' : 'modal-buttons__progress'}>
									{props.progressPercent} %
								</span>
						<Button
							color="primary"
							type="submit"
							className={props.isApkUpload ? 'invisible' : 'visible'}
						>
							{I18n[props.lang].upload}
						</Button>
						<Button color="secondary" className="ml-1" onClick={props.closeUploadModal}>{I18n[props.lang].cancel}</Button>
					</FormGroup>
				</Form>
				<div className="alert__comment">
					{props.uploadModal ? props.uploadMessage: ''}
					{props.uploadModal ? props.uploadComment :''}
				</div>
			</ModalBody>
		</Modal>
	)
};

export default UploadModal;



// WEBPACK FOOTER //
// ./src/components/CompanyMarket/UploadModal.js